import api from 'api';
import {
  dashboardMetaMenusAsyncActionSuccess,
} from 'actions/dashboard';

export const MENUS_ASYNC_ACTION_START = 'MENUS_ASYNC_ACTION_START';
export const MENUS_ASYNC_ACTION_SUCCESS = 'MENUS_ASYNC_ACTION_SUCCESS';
export const MENUS_ASYNC_ACTION_ERROR = 'MENUS_ASYNC_ACTION_ERROR';
export const MENUS_ASYNC_UPDATE_SUCCESS = 'MENUS_ASYNC_UPDATE_SUCCESS';
export const MENUS_RESET_STATE = 'MENUS_RESET_STATE';
export const MENUS_SET_DUPMENUID = 'MENUS_SET_DUPMENUID';

function menusAsyncActionStart() {
  return {
    type: MENUS_ASYNC_ACTION_START,
  };
}

function menusAsyncActionError(error) {
  return {
    type: MENUS_ASYNC_ACTION_ERROR,
    error,
  };
}

function menusAsyncActionSuccess() {
  return {
    type: MENUS_ASYNC_ACTION_SUCCESS,
  };
}

function menuAsyncUpdateSuccess(data) {
  return {
    type: MENUS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

export function resetMenusState() {
  return {
    type: MENUS_RESET_STATE,
  };
}

export function setDuplicatedMenuId(data) {
  return {
    type: MENUS_SET_DUPMENUID,
    data,
  };
}

export function getMenus(menuType = '', sourceType='') {
  return (dispatch, getState) => {

    dispatch(menusAsyncActionStart());
    return api.request(`menu/list?menuType=${ menuType }&sourceType=${ sourceType }`, 'get')
    .then((data) => {
      dispatch(menuAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menusAsyncActionError('Unable to get menus list'));
      throw (err);
    });
  };
}

export function getMenusCount(menuType = '') {
  return (dispatch, getState) => {
    dispatch(menusAsyncActionStart());
    return api.request(`menu/count?menuType=${ menuType }`, 'get')
    .then((data) => {
      dispatch(menusAsyncActionSuccess());
      dispatch(dashboardMetaMenusAsyncActionSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(menusAsyncActionError('Unable to get menus count'));
      throw (err);
    });
  };
}

export function duplicateMenuAsync(id) {
  return (dispatch, getState) => {
    dispatch(menusAsyncActionStart());
    return api.request(`menu/duplicateMenu?id=${ id }`, 'post')
    .then((data) => {
      dispatch(menusAsyncActionSuccess());
      return data;
    })
    .catch((err) => {
      dispatch(menusAsyncActionError('Unable to duplicate menu'));
      throw (err);
    });
  };
}
